// cursor-coins-mobile.js
(function(){
  if (window.__cursorCoinsLoaded) return;
  window.__cursorCoinsLoaded = true;

  // ---------- Config ----------
  const isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  const MOBILE = !!isTouchDevice;
  const SPAWN_INTERVAL = MOBILE ? 60 : 30;   // ms between spawns (throttle)
  const MAX_PARTICLES = MOBILE ? 120 : 400;
  const PARTICLES_PER_SPAWN = MOBILE ? 1 : 3;
  const GRAVITY = MOBILE ? 0.18 : 0.20;

  // ---------- Canvas + style ----------
  const style = document.createElement('style');
  style.textContent = `
    #cursor-coins-canvas{
      position: fixed;
      top:0;
      left:0;
      width:100vw;
      height:100vh;
      pointer-events:none;
      z-index:2147483647; /* highest so it appears above everything but won't catch events */
    }
  `;
  document.head.appendChild(style);

  const canvas = document.createElement('canvas');
  canvas.id = 'cursor-coins-canvas';
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');

  // DPR-aware sizing
  let dpr = Math.max(1, window.devicePixelRatio || 1);
  function resize() {
    dpr = Math.max(1, window.devicePixelRatio || 1);
    const w = Math.max(1, Math.ceil(window.innerWidth * dpr));
    const h = Math.max(1, Math.ceil(window.innerHeight * dpr));
    canvas.width = w;
    canvas.height = h;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    // draw in CSS pixels
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  window.addEventListener('resize', resize, { passive: true });
  resize();

  // ---------- Particles ----------
  const particles = [];
  let lastSpawnTime = 0;
  let lastPointer = { x: window.innerWidth/2, y: window.innerHeight/2 };

  function spawnCoins(x, y, count = PARTICLES_PER_SPAWN) {
    for (let i = 0; i < count; i++) {
      if (particles.length >= MAX_PARTICLES) {
        particles.shift();
      }
      const size = MOBILE ? (Math.random() * 10 + 8) : (Math.random() * 18 + 12);
      particles.push({
        x: x,
        y: y,
        vx: (Math.random() - 0.5) * (MOBILE ? 3.5 : 6),
        vy: - (Math.random() * (MOBILE ? 3 : 4) + (MOBILE ? 1.5 : 2)),
        size: size,
        life: 1.0,
        decay: 0.012 + Math.random() * 0.03,
        rot: Math.random() * Math.PI * 2,
        drot: (Math.random() - 0.5) * 0.2
      });
    }
  }

  // ---------- Sprite cache (pre-render coins) ----------
  const spriteCache = new Map();
  function createCoinSprite(size) {
    const key = Math.round(size);
    if (spriteCache.has(key)) return spriteCache.get(key);

    // create offscreen canvas
    const c = document.createElement('canvas');
    const sdpr = dpr;
    c.width = key * sdpr;
    c.height = key * sdpr;
    c.style.width = key + 'px';
    c.style.height = key + 'px';
    const sctx = c.getContext('2d');
    sctx.setTransform(sdpr, 0, 0, sdpr, 0, 0);

    const r = key / 2;

    // gradient coin body
    const g = sctx.createLinearGradient(-r, -r, r, r);
    g.addColorStop(0, '#ffef9a');
    g.addColorStop(0.5, '#ffd54d');
    g.addColorStop(1, '#ffb300');
    sctx.fillStyle = g;
    sctx.beginPath();
    sctx.arc(r, r, r, 0, Math.PI * 2);
    sctx.fill();

    // subtle stroke
    sctx.lineWidth = Math.max(1, key * 0.08);
    sctx.strokeStyle = 'rgba(0,0,0,0.12)';
    sctx.stroke();

    // highlight
    sctx.fillStyle = 'rgba(255,255,255,0.55)';
    sctx.beginPath();
    sctx.ellipse(r - r*0.22, r - r*0.33, r*0.44, r*0.24, 0, 0, Math.PI*2);
    sctx.fill();

    // glyph (₿). If not available, it will fallback visually.
    sctx.fillStyle = 'rgba(30,20,10,0.98)';
    sctx.font = `bold ${Math.round(key * 0.6)}px sans-serif`;
    sctx.textAlign = 'center';
    sctx.textBaseline = 'middle';
    sctx.fillText('₿', r, r);

    spriteCache.set(key, c);
    return c;
  }

  // ---------- Input handling (pointer + fallback) ----------
  function handlePointer(x, y, pointerType) {
    const now = Date.now();
    // throttle spawn to avoid huge number while scrolling on mobile
    if (now - lastSpawnTime < SPAWN_INTERVAL) {
      lastPointer.x = x; lastPointer.y = y;
      return;
    }
    lastSpawnTime = now;
    lastPointer.x = x; lastPointer.y = y;

    // spawn more for pointerdown/tap, less when just moving
    const spawnCount = (pointerType === 'touch') ? (MOBILE ? 1 : 2) : PARTICLES_PER_SPAWN;
    spawnCoins(x, y, spawnCount);
  }

  if (window.PointerEvent) {
    document.addEventListener('pointermove', function(e){
      if (!e.isPrimary) return; // only primary pointer
      handlePointer(e.clientX, e.clientY, e.pointerType || (e.pointerType === undefined ? 'mouse' : e.pointerType));
    }, { passive: true });
  } else {
    document.addEventListener('mousemove', function(e){
      handlePointer(e.clientX, e.clientY, 'mouse');
    }, { passive: true });
    document.addEventListener('touchmove', function(e){
      const t = e.touches[0];
      if (!t) return;
      handlePointer(t.clientX, t.clientY, 'touch');
    }, { passive: true });
    document.addEventListener('touchstart', function(e){
      const t = e.touches[0];
      if (!t) return;
      handlePointer(t.clientX, t.clientY, 'touch');
    }, { passive: true });
  }

  // ---------- Animation ----------
  let paused = false;
  document.addEventListener('visibilitychange', () => {
    paused = document.hidden;
    if (!paused) requestAnimationFrame(loop);
  }, { passive: true });

  function loop() {
    if (paused) return;
    // clear using CSS pixels
    ctx.clearRect(0, 0, canvas.width / dpr, canvas.height / dpr);

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];

      // physics
      p.vy += GRAVITY;
      p.vx *= 0.995;
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.drot;
      p.life -= p.decay;

      // remove offscreen or dead
      if (p.life <= 0 || p.y - p.size > window.innerHeight + 200) {
        particles.splice(i, 1);
        continue;
      }

      const alpha = Math.max(0, Math.min(1, p.life));
      const sprite = createCoinSprite(p.size);
      ctx.save();
      ctx.globalAlpha = alpha;
      // draw sprite (already drawn in center at size px)
      ctx.drawImage(sprite, p.x - p.size/2, p.y - p.size/2, p.size, p.size);
      ctx.restore();
    }

    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  // ---------- Small debug marker ----------
  canvas.setAttribute('data-cursor-coins', 'loaded');
  console.log('Cursor coins loaded (mobile-capable)');

})();